import { IMaintenanceProcessRule } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import { IEquipment, IEquipmentMaintenanceBlank } from '../pages/Equipment/equipment.types.ts'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import { IUser } from '@/pages/Users/users.types.ts'

const urls = {
  auth: '/auth',
  home: '/',
  dashboards: '/dashboards',
  main: '/main',
  map: '/equipment/map',
  aiAssistant: '/ai-assistant',
  processes: '/processes',
  archives: '/archives',
  maintenance: '/processes/maintenance',
  alarmSituations: '/processes/alarmSituations',
  calendar: '/maintenance/calendar',
  systemEvents: '/archives/system-events',
  schemasAndData: '/schemas-and-data',
  mdm: '/schemas-and-data/mdm',
  equipment: '/equipment',
  equipmentSettings: '/settings/equipment',
  lifts: '/equipment/lifts',
  liftPageMaintenanceCreateBlank: (equipmentId: IEquipment['id'], processRuleId: IMaintenanceProcessRule['id']) =>
    `${urls.lifts}/${equipmentId}/?processRuleId=${processRuleId}&selectedTab=journals`,
  liftPageMaintenanceViewBlank: (equipmentId: IEquipment['id'], blankId: IEquipmentMaintenanceBlank['id']) =>
    `${urls.lifts}/${equipmentId}/?selectedTab=journals&blankId=${blankId}`,
  liftScreen: (id: IEquipment['id']) => `/equipment/lifts/${id}`,
  liftMonitoring: (id: IEquipment['id']) => `/equipment/lifts/${id}/monitoring`,
  liftAnalysis: (id: IEquipment['id']) => `/equipment/lifts/${id}/analysis`,
  settings: '/settings',
  equipmentModels: '/settings/equipment-models',
  parameters: '/settings/parameters',
  organizations: '/settings/organizations',
  documentsLibrary: '/settings/library',
  organizationUsers: (organizationId: IOrganization['id']) => `/settings/organizations/${organizationId}/users`,
  myOrganization: '/my-organization',
  employePage: (id: IUser['id']) => `/my-organization/${id}`,
}

export default urls
